/**
 * Created by zed on 2021/9/19
 * Copyright © 2017 www.moemone.com. All rights reserved.
 *
 * 【路由器】
 *  1. 安装路由器
 *  2. 配置路由模块
 *  3. 构建路由器实例
 */

/* -- 安装路由器 -- */
import Vue from 'vue'
import VueRouter from "vue-router"
Vue.use(VueRouter)

/* -- 配置路由模块 -- */
import Layout from '@/layout/Layout'

const routerModule = process.env.VUE_APP_ROUTER_MODULE
let constantRouters = []

if (routerModule) {
  try {
    constantRouters = require(`@/router/modules/${routerModule}`).default
    console.log(`[Router] Loaded module: ${routerModule}`)
  } catch (e) {
    console.error(`[Router] Failed to load module: ${routerModule}`, e)
  }
} else {
  console.warn('[Router] No VUE_APP_ROUTER_MODULE environment variable defined.')
}

/* -- 构建路由器实例 -- */
const createRouter = () => new VueRouter({
  mode: 'history',
  routes: constantRouters
})

const router = createRouter()

export default router
